<div class="chart-component">
  <div class="legend">
    <div
      class="legend-item"
      *ngFor="let legend of data.legend"
      #legendItem
      (click)="onLegendClick(legend)"
      (mouseover)="onMouseOver($event)"
      (mouseout)="onMouseOver($event)"
      [ngClass]="legend.selected ? '' : 'inactive'"
    >
      <span
        class="legend-color"
        [ngStyle]="getLegendColorStyle(legendItem, legend)"
      >
      </span>
      <span
        class="legend-text"
        [innerHTML]="legend.name + ' ' + legend.value"
      ></span>
    </div>
    <div
      class="show-all"
      (click)="onShowAllClick()"
      (mouseover)="onMouseOver($event)"
      (mouseout)="onMouseOver($event)"
      [ngClass]="showAllEnabled ? '' : 'inactive'"
    >
      <span class="show-all-text">
        <i class="fa fa-refresh" data-icon></i> Show All
      </span>
    </div>
  </div>
  <svg class="chart"></svg>
</div>
